import React, { FunctionComponent } from 'react';
import "./error.scss"
import Text from '../../components/typography/typgraphy';
import errorIcon from '../../assets/images/error.svg'

const PageNotFound: FunctionComponent = () => {
  return (
    <div className="common-error-container">
      <div className="error-wrapper">
        <div className="error-description-container">
          <img className="error-icon" src={errorIcon} alt="error" />
          <Text className="error-heading">Uh Oh!</Text>
          <Text className="error-sub-heading">We are Sorry!</Text>
          <Text className="error-description">Seems like you are lost</Text>
          <Text className="error-description">Please visit your nearest Axis Bank branch for any queries and then re-initiate your transaction.</Text>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound;
